import { InjectionToken, TemplateRef } from '@angular/core';

export const LIST_ITEM_TEMPLATE = new InjectionToken<TemplateRef<any>>('ListItemTemplate');
